import { createContext, useContext, useState } from 'react';

// 1. Create the context object — this is the "channel" that data flows through.
const UserContext = createContext(null);

// 2. Create a provider component — this wraps part of the component tree
//    and makes the data available to everything inside it.
export const UserProvider = ({ children }) => {
	const [user, setUser] = useState(null);

	return (
		<UserContext.Provider value={{ user, setUser }}>
			{children}
		</UserContext.Provider>
	);
};

// 3. Create a custom hook — a shorthand so consumers don't need to
//    import both useContext and UserContext every time.
export const useUser = () => useContext(UserContext);
